import React, { useState } from 'react';
import Styled from 'styled';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client/react/hooks';
import { FormattedMessage } from 'react-intl';

import { Site } from 'four-nets/site';
import Select from 'four-nets/ui-v2/form/select/select';
import countySelectQuery, {
    CountySelectQuery,
    CountySelectQueryVariables,
} from 'four-nets/photoblog/users/county-select/county-select-query.graphql';
import countriesQuery, { CountriesQuery } from './countries.graphql';

import defaultStyles from './geo-select.scss';

export interface Props {
    allowCountrySelection: boolean;
    countyId?: string | null;
    countryId?: string | null;
    onChange: (selectedCountyID?: string | null, selectedCountryID?: string | null) => void;
    styles: typeof defaultStyles;
}

const GeoSelect: React.FC<Props> = (props, context) => {
    let countryName;
    if (context && context.site.isSlovak) {
        countryName = 'SLOVAKIA';
    } else if (context && context.site.isCzech) {
        countryName = 'CZECH_REPUBLIC';
    }

    const { styles, onChange, allowCountrySelection: allowCountrySelection, countryId, countyId, ...rest } = props;

    const value = countyId || countryId || '';

    const [isCountySelect, setIsCountySelect] = useState(value === countyId);

    const { data: countiesData } = useQuery<CountySelectQuery, CountySelectQueryVariables>(countySelectQuery, {
        variables: { countryName },
    });

    const { data: countriesData } = useQuery<CountriesQuery>(countriesQuery);

    return (
        <div className={styles.wrapper}>
            <Select
                {...rest}
                style={{
                    select: styles.selectSelect,
                }}
                multiple={false}
                value={value}
                onChange={event =>
                    onChange(isCountySelect ? event.target.value : '', isCountySelect ? '' : event.target.value)
                }
            >
                {isCountySelect ? (
                    <FormattedMessage id='ALL_COUNTIES'>
                        {message => <option value=''>{message}</option>}
                    </FormattedMessage>
                ) : (
                    <FormattedMessage id='ALL_COUNTRIES'>
                        {message => <option value=''>{message}</option>}
                    </FormattedMessage>
                )}
                {isCountySelect
                    ? countiesData && countiesData.counties && countiesData.counties.edges
                        ? countiesData.counties.edges.map(edge => {
                              if (edge && edge.node) {
                                  const { name, id } = edge.node;
                                  return (
                                      <option key={id} value={id}>
                                          {name}
                                      </option>
                                  );
                              }

                              return null;
                          })
                        : null
                    : countriesData && countriesData.countries && countriesData.countries.edges
                    ? countriesData.countries.edges.map(edge => {
                          if (edge && edge.node) {
                              const { name, id } = edge.node;
                              return (
                                  <option key={id} value={id}>
                                      {name}
                                  </option>
                              );
                          }

                          return null;
                      })
                    : null}
            </Select>
            {allowCountrySelection ? (
                <button
                    type='button'
                    className={styles.button}
                    onClick={() => {
                        onChange('', '');
                        setIsCountySelect(!isCountySelect);
                    }}
                >
                    {isCountySelect ? (
                        <FormattedMessage id='SELECT_OTHER_COUNTRY_THAN_HOME_COUNTRY' values={{ gender: 'v' }} />
                    ) : (
                        <FormattedMessage id='SELECT_COUNTY_FROM_HOME_COUNTRY' values={{ gender: 'v' }} />
                    )}
                </button>
            ) : null}
        </div>
    );
};

GeoSelect.contextTypes = {
    site: PropTypes.instanceOf(Site),
};

export default Styled(defaultStyles)(GeoSelect);
